import React from "react";
import {Drawer } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { MessageLayout, CloseIconFrame, InfoMsg, PopUpTitle } from './styles';
import { useStyles } from './styles';

const CustomDrawer = (props) => {
    const classes = useStyles();
    const {isDrawer} = props;
    return (

        <Drawer anchor={"bottom"} open={isDrawer} classes={{paper: props.rounded ? classes.roundedBorderDrawer : ""}} style={props.zIndex ? { zIndex: props.zIndex } : undefined}>
           <div className={classes.container}>
            <CloseIconFrame noBorder={props.noBorder} noMargin={props.noMargin}>
                    <div>
                    <PopUpTitle>{props.title}</PopUpTitle>
                    </div>
                    <div>
                    {props.dismiss && <CloseIcon onClick={props.dismiss} className={classes.closeIcon} />}
                    </div>
                </CloseIconFrame>  
            <MessageLayout> 
                <InfoMsg noMargin={props.noMargin} noPadding={props.noPadding}>
                    {props.message}
                </InfoMsg>
            </MessageLayout>
        </div>
        </Drawer>
)
}

export default CustomDrawer;
